import React from 'react'
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const DotsComponent = () => {
  return (
      <div className="dot-div" >
            <MoreHorizIcon className="dots" style={{height:"13px"}}/>
        </div>
  )
}

export default DotsComponent
